import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  root: {
    marginTop: theme.spacing(12),

    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(6),
    },
  },

  wrapRoot: {
    position: 'relative',
    minHeight: 290,
    overflow: 'hidden',

    [theme.breakpoints.down('sm')]: {
      minHeight: 334,
    },
  },

  chart: {
    position: 'absolute',
    left: 0,
    bottom: 24,

    [theme.breakpoints.down('sm')]: {
      bottom: 0,
    },
  },

  panel: {
    display: 'flex',
    justifyContent: 'space-between',

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      rowGap: theme.spacing(5),
    },
  },
}));
